import React from 'react';

import ResponsiveTable from './responsive_table';

/*
 * The module's data table: one tree picked from the container width (responsive_table.jsx), the
 * richest layout that fits without sideways scroll. `responsive` is accepted for older callers.
 */
const DataTable = ({ responsive, ...props }) => <ResponsiveTable {...props} />;

export default DataTable;
